module.exports = __webpack_public_path__ + "img/Profil_CS-Hybrid_Universal.jpg,.6ab910f0.jpg";